var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.72 2.81004C21.65 2.55004 21.45 2.35004 21.19 2.28004C18.17 1.48004 15.14 2.32004 13.34 4.26004H6C3.93 4.26004 2.25 5.94004 2.25 8.01004V18.01C2.25 20.08 3.93 21.76 6 21.76H16C18.07 21.76 19.75 20.08 19.75 18.01V15.01C19.75 14.6 19.41 14.26 19 14.26C18.59 14.26 18.25 14.6 18.25 15.01V18.01C18.25 19.25 17.24 20.26 16 20.26H6C4.76 20.26 3.75 19.25 3.75 18.01V8.00004C3.75 6.76004 4.76 5.75004 6 5.75004H12.3C11.36 7.72004 11.77 9.71004 12.14 10.81L9.48 13.47C9.19 13.76 9.19 14.24 9.48 14.53C9.63 14.68 9.82 14.75 10.01 14.75C10.2 14.75 10.39 14.68 10.54 14.53L13.2 11.87C13.8 12.07 14.66 12.29 15.65 12.29C16.49 12.29 17.42 12.13 18.35 11.68C21.29 10.23 22.72 6.50004 21.74 2.82004L21.72 2.81004ZM14.41 10.65L16.53 8.53004C16.82 8.24004 16.82 7.76004 16.53 7.47004C16.24 7.18004 15.76 7.18004 15.47 7.47004L13.35 9.59004C13.17 8.71004 13.1 7.49004 13.67 6.34004C14.73 4.18004 17.56 3.06004 20.37 3.63004C20.94 6.44004 19.82 9.27004 17.66 10.33C16.5 10.9 15.29 10.83 14.41 10.65Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.25H7C6.59 16.25 6.25 16.59 6.25 17C6.25 17.41 6.59 17.75 7 17.75H15C15.41 17.75 15.75 17.41 15.75 17C15.75 16.59 15.41 16.25 15 16.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letter-icon.d37d05603da5560c96235c8f16f29f41.svg";
export { ForwardRef as ReactComponent };